import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCvX3-b_Nwwzf5HptNvPYZXoma8B7OMuRs",
  authDomain: "mastermind-3cf3e.firebaseapp.com",
  projectId: "mastermind-3cf3e",
  storageBucket: "mastermind-3cf3e.firebasestorage.app",
  messagingSenderId: "281161693585",
  appId: "1:281161693585:web:371020bb0c52e47db54230",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
